
define('ldsh!modules/start/products/trans/activity/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="col-xs-8 col-sm-10 col-md-10 col-lg-10">\n   <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <h3 class="i18n" style="margin-top: 5px;" data-i18n="PUBLIC.PRODUCTS.TRANS.PRODUCT_NAME"></h3>\n        </div>\n   </div>\n   <div class="row">\n       <div class="col-md-12 col-lg-12">\n            <p><b class="i18n" data-i18n="PUBLIC.PRODUCTS.TRANS.INFO.SUBTITLE"></b></p>\n            <table>\n                <tr>\n                    <td style="vertical-align: top;"><img class="product-check" src="/app/img/check_20.png"/></td>\n                    <td><span class="i18n" data-i18n="PUBLIC.PRODUCTS.TRANS.INFO.CHECK1"></span></td>\n                </tr>\n            </table>\n       </div>\n   </div>\n</div>\n';

}
return __p
};});

